import { Box, Button, Grid, TextField, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Title = styled(Typography)(() => ({
  fontSize: '32px',
  margin: '20px 0',
  fontWeight: 600,
}));

export const ContainerGrid = styled(Grid)(({ theme }) => ({
  display: 'flex',
  width: '100%',
  minHeight: '720px',
  height: '100vh',
  justifyContent: 'center',
  background: theme.palette.primary.main,
}));

export const LogoGrid = styled(Grid)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

export const LogoImg = styled(Box)(({ theme }) => ({
  zIndex: 5,
  img: {
    [theme.breakpoints.down('lg')]: {
      width: 400,
    },
    [theme.breakpoints.up('lg')]: {
      width: 547,
    },
  },
}));

export const LoginGrid = styled(Grid)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: theme.palette.common.white,
  borderTopLeftRadius: '30px',
  borderBottomLeftRadius: '30px',
}));

export const InputBox = styled(Box)(() => ({
  width: '80%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '20px',
  marginTop: '60px',
}));

export const ExternalInputBox = styled(Box)(() => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '60px',
}));

export const StyledTextField = styled(TextField)(({ theme }) => ({
  fontSize: '18px',
  width: '100%',
  marginBottom: '20px',
  '& .MuiInputBase-input': {
    color: theme.palette.common.black,
    fontSize: '16px',
  },
  '& .MuiInputBase-root.MuiInput-root:before': {
    borderBottom: `1px solid ${theme.palette.common.grey}`,
  },
  '& .MuiInputBase-root.MuiInput-root:after': {
    borderBottom: `1px solid ${theme.palette.common.grey}`,
  },
  '& .MuiInputBase-root.MuiInput-root.Mui-error:before': {
    borderBottom: '1px solid #d32f2f',
  },
  '& .MuiInputBase-root.MuiInput-root.Mui-error:after': {
    borderBottom: '1px solid #d32f2f',
  },
  '& .MuiInputBase-root.MuiInput-root:hover:before': {
    borderBottom: `1px solid ${theme.palette.secondary.main}`,
  },
  '& .MuiInputBase-root.MuiInput-root:hover:after': {
    borderBottom: `1px solid ${theme.palette.secondary.main}`,
  },
  'input:hover::-webkit-input-placeholder': { color: 'transparent' },
  'input:-webkit-autofill': {
    WebkitBoxShadow: '0 0 0px 1000px #F2F2F2 inset',
    paddingLeft: '10px',
  },
}));

export const FilledButton = styled(Button)(({ theme }) => ({
  width: '100%',
  backgroundColor: theme.palette.primary.main,
  textTransform: 'uppercase',
  borderRadius: '16px',
  '&:hover': {
    filter: 'brightness(85%)',
  },
  marginTop: 21,
}));
